import {GET_AdminFillProgramId} from '../constants/ActionTypes'

const INIT_STATE = {
    AdminProgram: null,
    Message:''
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case GET_AdminFillProgramId:
            return {
                AdminProgram: action.body,
                Message:action.msg
              
            }
           

        default:
            return state;
    }
}